module.exports = __webpack_public_path__ + "img/gulerodsmuffins.5edc4c1d.jpg";